export enum TieBreakerRotateOut {
	BOTH_TEAM_ROTATE_OUT = 'ROTATE_OUT_BOTH_TEAMS',
	TEAM_THAT_REACHED_POINT = 'ROTATE_OUT_TEAM_THAT_REACHED_POINTS_FIRST'
}

export enum TieBreakerType {
	CUSTOM = 'TIE_BREAKER_CUSTOM',
	MLP_DREAM_BREAKER = 'TIE_BREAKER_4_PLAYER_MLP_STYLE_DREAMBREAKER'
}

export enum TieBreakerFormatType {
	SINGLES = 'Singles',
	DOUBLES = 'Doubles',
	SKINNY_SINGLES = 'Skinny Singles'
}

export enum TieBreakerPlayerGroupType {
	COED = 'Coed',
	WOMENS = 'Womens',
	MANS = 'Mens',
	MIXED = 'Mixed'
}

export enum TieBreakerLineupSelectionType {
	TIE_REACHED = 'LINEUP_SELECTION_TIE_REACHED',
	BEFORE_MATCHUP_STARTS = 'LINEUP_SELECTION_BEFORE_MATCHUP_STARTS'
}
export interface TieBreakerFormat {
	id: string;
	title: string;
	displayOrder: number;
	isEnabled: boolean;
	partnerNeeded: boolean;
	shortHand: string;
}

export interface TieBreakerScoreFormat {
	scoreFormatId: string;
	title: string;
	shorthand: string;
	maxGames: number;
	gameBest: number;
	gameBestOutOf: number;
	rrMatchMaxWinnerPoints: number;
	rrMatchMaxLoserPoints: number;
	game1Max: number;
	game1WinBy: number;
	game2Max: number;
	game2WinBy: number;
	game3Max: number;
	game3WinBy: number;
	game4Max: number;
	game4WinBy: number;
	game5Max: number;
	game5WinBy: number;
	estMinutesPerMatch: number;
	displayOrder: number;
	isEnabled: boolean;
	showForTourney: boolean;
	showForLeague: boolean;
	usapEnabled: boolean;
	pcoEnabled: boolean;
	ssipaEnabled: boolean;
	pickleballTournamentsDotComEquivalent: string;
}

export interface TieBreakerPlayerGroup {
	id: string;
	title: string;
	description: string;
	displayOrder: number;
}

export interface TieBreakerSettings {
	tieBreaker: string;
	tieBreakerPlayerGroup: TieBreakerPlayerGroup;
	tieBreakerFormat: TieBreakerFormat;
	tieBreakerScoreFormat: TieBreakerScoreFormat;
	tieBreakerOneMinTimeoutPerGame: number;
	tieBreakerEstMatchTime: number;
	tieBreakerRotateOut: string;
	tieBreakerRotatePlayer: number;
	tieBreakerMaxTotalPtsPriorToRotatingOut: number;
	tieBreakerLineupSelection: string;
	tieBreakerChangeToSideOutScoringPoints: number;
}
